import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AxiosError } from 'axios';
import { Action } from 'redux';
import { useToast } from '@app/core';
import { ApiFormattedException } from '../store/modules/exceptions';
import { i18n } from 'i18n';

/**
 * @deprecated use react-query instead
 */
export const useFetchedEntity = (
  thunk: Function,
  id?: string | null,
  ...params: any[]
) => {
  const [fetching, setFetching] = useState(true);
  const dispatch = useDispatch<ThunkDispatch<any, void, Action>>();
  const toast = useToast();

  useEffect(() => {
    if (!id) {
      setFetching(false);
      return;
    }
    (async () => {
      setFetching(true);
      try {
        await dispatch(thunk(id, ...params));
      } catch (e) {
        const response = (e as AxiosError).response;
        if (response && response.status === 404) {
        } else {
          toast.exception(e);
        }
      }
      setFetching(false);
    })();
    // eslint-disable-next-line
  }, [dispatch, toast, id, thunk, setFetching]);

  return { fetching, setFetching };
};
